import { createApp } from 'vue'

import BaseAlert from '@/src/vueComponent/BaseAlert.vue'
import UserSearch from '@/src/javascripts/settings/users/UserSearch.vue'

$(document).on('turbo:load turbo:render', () => {
  const userIndex = document.querySelector('#user-index')
  if (userIndex && !userIndex.__vue_app__) {
    createApp({ components: { BaseAlert, UserSearch } }).mount(userIndex)
  }
})
